import {
  DATA_VIEW_GENERAL_WRAPPER_CLASS,
  DataViewAvailableDisplayModel,
  DataViewsPresenterModel,
  EntityViewTypeEnum,
  EntryActionOperationEnum,
} from '@osos/shared/types';

export function hasCreatePermission(view: DataViewsPresenterModel): boolean {
  return (
    !!view &&
    !!view.editConfiguration?.enabled &&
    view.editConfiguration?.supportedOperations?.some(
      (_op) =>
        _op.operationType === EntryActionOperationEnum.AllowCreateNewEntries,
    )
  );
}

export function hasEditPermission(view: DataViewsPresenterModel): boolean {
  return (
    !!view &&
    !!view.editConfiguration?.enabled &&
    view.editConfiguration?.supportedOperations?.some(
      (_op) => _op.operationType === EntryActionOperationEnum.AllowEditEntries,
    )
  );
}

export function hasAskForUserPermission(
  view: DataViewsPresenterModel,
): boolean {
  return (
    !!view &&
    !!view.editConfiguration?.enabled &&
    view.editConfiguration?.supportedOperations?.some(
      (_op) => _op.operationType === EntryActionOperationEnum.AllowAskUserFor,
    )
  );
}

export function hasInlineEditPermission(
  view: DataViewsPresenterModel,
): boolean {
  return (
    !!view &&
    !!view.editConfiguration?.enabled &&
    view.editConfiguration?.supportedOperations?.some(
      (_op) =>
        _op.operationType === EntryActionOperationEnum.AllowEditEntries &&
        _op.allowInlineEdit,
    )
  );
}

export function hasArchivePermission(view: DataViewsPresenterModel): boolean {
  return (
    !!view &&
    !!view.editConfiguration?.enabled &&
    view.editConfiguration.supportedOperations.some(
      (_op) =>
        _op.operationType === EntryActionOperationEnum.AllowArchiveEntries,
    )
  );
}

export function getViewTableMaxDisplayedValues(view: DataViewsPresenterModel) {
  const tableFaceDisplay: DataViewAvailableDisplayModel =
    view.viewConfiguration?.availableDisplays?.find(
      (_viewDisplay) => _viewDisplay.viewType === EntityViewTypeEnum.TableView,
    );
  return (
    tableFaceDisplay?.configuration?.tableViewConfiguration?.maxDisplayedValues
      ?.multiValueField ?? 1
  );
}

export function hasAllowChangeFields(view: DataViewsPresenterModel) {
  const tableFaceDisplay: DataViewAvailableDisplayModel =
    view.viewConfiguration?.availableDisplays?.find(
      (_viewDisplay) => _viewDisplay.viewType === EntityViewTypeEnum.TableView,
    );
  return tableFaceDisplay?.configuration?.tableViewConfiguration
    ?.allowChangeFields;
}

let viewGeneralClassCount = 0;
export function getViewGeneralStyleId() {
  return DATA_VIEW_GENERAL_WRAPPER_CLASS + viewGeneralClassCount++;
}
